import React, { useEffect, useRef } from 'react';

import { styled } from '@mui/material/styles';
import { Box } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import { custom1 } from 'common/utils/customScrolls';

import SortableList from './SortableList';

const AsideColWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    height: calc(100% - 94px);
    width: 180px;
    overflow-y: scroll;
    padding-bottom: 24px;
    ${custom1}
`;

const AsideCol = ({
    selectedPageId,
    canUpdate,
    onDuplicatePage,
    onDeletePage,
    pages,
    selectPage,
    updateOrder,
}) => {
    const inputEl = useRef(null);

    let refDictionary = {};
    let scrollDisabled = false;

    useEffect(() => {
        if (
            !scrollDisabled &&
            inputEl.current &&
            selectedPageId &&
            refDictionary[selectedPageId]
        ) {
            inputEl.current.scrollTop =
                refDictionary[selectedPageId].offsetTop - 98;
        }

        if (scrollDisabled) {
            scrollDisabled = false;
        }
    }, [selectedPageId]);

    const onDragEnd = (result) => {
        const { destination, source } = result;
        if (!destination) {
            return;
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }
        updateOrder(source.index, destination.index);
    };
    return (
        <AsideColWrapper ref={inputEl}>
            {!isEmpty(pages) && (
                <SortableList
                    canUpdate={canUpdate}
                    handleClickDelete={onDeletePage}
                    handleClickDuplicate={onDuplicatePage}
                    handleClickSelect={selectPage}
                    id="page-list"
                    selectedPageId={selectedPageId}
                    onDragEnd={onDragEnd}
                    items={pages}
                    refDictionary={refDictionary}
                    scrollDisabled={scrollDisabled}
                />
            )}
        </AsideColWrapper>
    );
};

AsideCol.propTypes = {
    canUpdate: PropTypes.bool,
    onDuplicatePage: PropTypes.func,
    onDeletePage: PropTypes.func,
    pages: PropTypes.array,
    selectedPageId: PropTypes.string,
    selectPage: PropTypes.func,
    updateOrder: PropTypes.func,
};

export default AsideCol;
